import React, { useEffect, useRef, useState } from "react";
import {primaryInput} from "detect-it";
import { isMobile } from "../../globals/helpers";
import { AnimatePresence, motion } from "framer-motion";
import './styles.css';
import { loaderClipperVariants, loaderTextVariants, loaderWrapperVariants, overlayVariants, overlayVariants2, percentVariants, posterTextCenterVariants, posterTextVariants, strikethroughVariants, testPath, testPath2 } from "./variants";
import { boxExpandBezier, boxExpandDuration, boxExpandFinish, boxExpandStart, cubeFinish, maskExpandDuration, maskFadeDuration, maskfadeStart, maskUpDuration, maskUpEnd, maskUpStart, videoInStart, videoShrinkDuration, wiperEnd } from "./variables";
import { useLocation } from "react-router-dom";
import { projData } from "../../globals/data";
import { imageSizingMapping } from "../../globals/variables";


const Loader = ({setIsLowPowerMode}) => {
    const [isMobView, setIsMobView] = useState(null);
    const [startPreloader, setStartPreloader] = useState(false);
    const [isTouchscreen, setIsTouchScreen] = useState(null);
    const location = useLocation();
    const [isHome, setIsHome] = useState(null);
    const [homeStartingWidth, setHomeStartingWidth] = useState(null);
    const [homeScalers, setHomeScalers] = useState(null);
    const [percentVal, setPercentVal] = useState(0);
    const startTimeRef = useRef(null);
    const [animOutContent, setAnimOutContent] = useState(false);
    const animationFrameRef = useRef(null); 
    const [screenSize, setScreenSize] = useState(null);
    const bgVideoRef = useRef(null);
    const [useMobileVideoPreload, setUseMobileVideoPreload] = useState(null);
    const textOutPreTime = 1;

    function easeInOutExpo(x: number): number {
        return x === 0
          ? 0
          : x === 1
          ? 1
          : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2
          : (2 - Math.pow(2, -20 * x + 10)) / 2;
        }

    const handleBgLoad = () => {
        setStartPreloader(true)
    }

    const updateTimer = () => {
        // Calculate the elapsed time by checking the difference between current time and start time
        const currentTime = Date.now();
        const timeElapsed = (currentTime - startTimeRef.current) / 1000; // Convert from ms to seconds

        let prog = timeElapsed/(videoInStart-textOutPreTime);
        let curveProg  = easeInOutExpo(prog)
        let prct = (curveProg * 100).toFixed(0);
        
        if(curveProg < 0.99){
            requestAnimationFrame(updateTimer);
            if(curveProg < 0.1){
                setPercentVal((100*curveProg/1.5).toFixed(0) )
            } else if(curveProg < 0.85 && curveProg > 0.4){
                let delta = curveProg - 0.4;
                let deltaProg = delta / 0.45
                let adjusted = ((0.42 + (deltaProg * 0.05)) * 100).toFixed(0)
                setPercentVal(adjusted)
            }else{
                setPercentVal(prct)
            }
        }
        else{
            setAnimOutContent(true);
            setTimeout(() => {
                setPercentVal(100)
            }, 500)
            return
        }
        // let curProg = (cachedElapedTime + timeElapsed)/videoDuration;
        // if(curProg < 0.99){
        //     requestAnimationFrame(updateTimer);
        // } else{
        // }
    };

    const responsiveResize = () => {
        let curWidth = window.innerWidth;
        let curHeight = window.innerHeight;

        let tmpisMob = isMobile(curWidth, curHeight, true);
        setIsMobView(tmpisMob)
        let tmpScreenSize;
        Object.entries(imageSizingMapping).forEach(([key, value]) => {
            if(curWidth>= value[0] && curWidth <= value[1]){
                tmpScreenSize = key;
            }
        });
        setScreenSize(tmpScreenSize);


        if (primaryInput == "touch" && window.innerWidth > 600){
            // tablet   
            let maxTileWidth = (window.innerHeight/4) * 1.25 * 1.33;
            if (maxTileWidth <= 600)setUseMobileVideoPreload(true); else setUseMobileVideoPreload(false);
        } else if(primaryInput == "touch"){
            // mobile
            setUseMobileVideoPreload(true)
        } else if (primaryInput == "mouse"){
            let maxTileWidth = (window.innerHeight/5) * 2.25;
            if (maxTileWidth <= 600)setUseMobileVideoPreload(true); else setUseMobileVideoPreload(false);
        }




        if(primaryInput !== 'mouse') setIsTouchScreen(true); else setIsTouchScreen(false);

        return() => {
            window.removeEventListener('resize', responsiveResize);
        }
    }

    useEffect(() => {
        if(isMobView !== null && isTouchscreen !== null && isHome !== null){
            if(!isMobView && isHome){
                if(isTouchscreen){ // tablet
                    let targetHeight = (window.innerHeight/4)- 20;
                    let targetWidth = targetHeight * 1.33 * 1.25;

                    setIsMobView(false)
                } else{ // desktop
                    let targetHeight = (window.innerHeight/5)- 20;
                    let targetWidth = targetHeight * 2.25 + 40;
                    setIsMobView(false)
                }
            }else{
            }
        }
    }, [isMobView, isTouchscreen, isHome])


    useEffect(() => {
        if(bgVideoRef.current){
            try{
                let promise = bgVideoRef.current.play();
                if (promise !== undefined) {
                    promise
                      .catch(error => {
                        // Auto-play was prevented
                        // Show a UI element to let the user manually start playback
                        if (error.name === "NotAllowedError") {
                            // setIsLowPowerMode(true);
                            bgVideoRef.current.remove();
                            bgVideoRef.current.style.display = "block";
                          }
                        
                      })
                  } 

            }catch{}
        }
    }, [bgVideoRef.current])

    useEffect(() => {
        window.addEventListener('resize', responsiveResize());
        startTimeRef.current = Date.now();
        animationFrameRef.current = requestAnimationFrame(updateTimer)

        let curPath = location.pathname;
        if(curPath == '/'){
            let targetHeight = (window.innerHeight/5) - 20;
            let targetWidth = (window.innerHeight/5) * 2.25;
            let targetAspectRatio = targetWidth/targetHeight;

            let startingHeight = window.innerHeight;
            let startingWidth = startingHeight * targetAspectRatio;
            setHomeStartingWidth(startingWidth);

            let yScaler = targetHeight / startingHeight;
            let xScaler = targetWidth / startingWidth;


            setHomeScalers([xScaler, yScaler]);



        } else{
            setIsHome(false)
        }
    }, [])

    return(
        <>
        {
            isMobView !== null &&screenSize &&
            <>
                <motion.div 
                    className="loader-clipper"
                    style={{
                        width: "100vw",
                        height: "100dvh",
                        position: "absolute",
                        zIndex: 99999,
                    }} 
                    initial="initial"
                    animate="animate"
                    variants={isMobView ? loaderWrapperVariants : {}}
                >
                    <motion.video
                        muted
                        autoPlay
                        playsInline
                        loop
                        ref={bgVideoRef}
                        onCanPlayThrough={handleBgLoad}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100dvh",
                            zIndex: 200,
                            objectFit: "cover",
                            background: "var(--dark-color)"
                        }}
                        initial={{
                            opacity: 1,
                        }}
                        animate={{
                            opacity: 0,
                            transition: {
                                duration: isHome ? 0.25 : 0.75,
                                delay: videoInStart,
                                ease: [0.87, 0, 0.13, 1]
                            }
                        }}exit={{
                            opacity: 0,
                            transition: {
                            duration: 0.5
                        }}}
                    >
                        <source src="../media/showreel_test_5.mp4" type="video/mp4"/>
                    </motion.video>
                    <div className="loader__wrapper">
                        <div className="cube-wrapper">
                            <div className="loader-cube">
                                <div className="firstChar loader-char"
                                    style={{
                                        animationDelay: "0s",
                                        animationDuration: "1.2s",
                                        animationTimingFunction: "cubic-bezier(0.83, 0, 0.17, 1"
                                    }}
                                >
                                    <span>D</span>
                                </div>
                                <div className="fromBottomOutRight loader-char"
                                    style={{
                                        animationDelay: "0.6s",
                                        animationDuration: "1.2s",
                                        animationTimingFunction: "cubic-bezier(0.83, 0, 0.17, 1"
                                    }}
                                >
                                    <span>O</span>
                                </div>
                                <div className="fromLeftOutTop loader-char"
                                    style={{
                                        animationDelay: "1.2s",
                                        animationDuration: "1.2s",
                                        animationTimingFunction: "cubic-bezier(0.83, 0, 0.17, 1"
                                    }}
                                >
                                    <span>N</span>
                                </div>
                                <div className="fromBottomOutLeft loader-char"
                                    style={{
                                        animationDelay: "1.8s",
                                        animationDuration: "1.2s",
                                        animationTimingFunction: "cubic-bezier(0.83, 0, 0.17, 1"
                                    }}
                                >
                                    <span>P</span>
                                </div>
                                <div className="fromRightOutTop loader-char" style={{
                                    animationDelay: "2.4s",
                                    animationDuration: "1.2s",
                                    animationTimingFunction: "cubic-bezier(0.83, 0, 0.17, 1"
                                }}>
                                    <span>R</span>
                                </div>
                                <div className="fromBottomOutLeft loader-char" style={{
                                    animationDelay: "3s",
                                    animationDuration: "1.2s",
                                    animationTimingFunction: "cubic-bezier(0.83, 0, 0.17, 1"
                                }}>
                                    <span>O</span>
                                </div>
                                <div className="fromRightOutTop loader-char" style={{
                                    animationDelay: "3.6s",
                                    animationDuration: "1.2s",
                                    animationTimingFunction: "cubic-bezier(0.83, 0, 0.17, 1"
                                }}>
                                    <span>D</span>
                                </div>
                                
                                
                            </div>
                            
                        </div>
                    </div>
                    <motion.div 
                        className="loader-perc__wrapper"
                        initial="initial"
                        animate={!animOutContent ? "animate" : "exit"}
                    >
                        <motion.span variants={percentVariants} custom={0}>{percentVal}</motion.span>
                        <motion.span variants={percentVariants} custom={1}>%</motion.span>
                    </motion.div>
                    <motion.div 
                        className="loader-poster__wrapper"
                        initial="initial"
                        animate={!animOutContent ? "animate" : "exit"}
                    >
                        
                        <div className="poster-text lower-loader-text__wrapper">
                            <motion.span variants={posterTextVariants} 
                                custom={0}
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                }}    
                            >DIRECTOR SHOWCASE 
                                { !isMobView && <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                    marginLeft: "12px"
                                }}>
                                    <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                    marginLeft: "6px"
                                }}>
                                    <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                </svg>
                                </>}
                            </motion.span>

                            {
                                isMobView &&
                                <motion.span 
                                    variants={posterTextVariants} 
                                    custom={0}
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                    }}
                                >
                                     <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                            marginRight: "3px"
                                        }}>
                                            <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                            marginRight: "10px"
                                        }}>
                                            <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                    </svg>
                                </motion.span>
                            }
                                {!isMobView ?
                                <motion.span 
                                    variants={posterTextCenterVariants} custom={1}
                                    style={{
                                        position: "absolute",
                                        left: "50%",
                                        transform: "translate3d(-50%, 0, 0)"
                                    }}
                                    >DOUBLE OR <span style={{
                                        position: "relative"
                                    }}>
                                        NOTHING
                                        <motion.span 
                                            variants={strikethroughVariants}
                                            style={{
                                                width: "100%",
                                                position: "absolute",
                                                top: "50%",
                                                height: "2px",
                                                left: 0,
                                                background: "var(--don-red)",
                                                transform: "translate3d(0, -50%, 0) scale3d(0, 1, 1)",
                                                transformOrigin: "left"
                                            }}
                                        />    
                                    </span></motion.span>
                                    :
                                    <>
                                        <motion.span 
                                        variants={posterTextVariants} custom={1}
                                        >DOUBLE OR&nbsp;
                                        <span style={{
                                            position: "relative"
                                        }}>
                                            NOTHING
                                            <motion.span 
                                                variants={strikethroughVariants}
                                                style={{
                                                    width: "100%",
                                                    position: "absolute",
                                                    top: "50%",
                                                    height: "2px",
                                                    left: 0,
                                                    background: "var(--don-red)",
                                                    transform: "translate3d(0, -50%, 0) scale3d(0, 1, 1)",
                                                    transformOrigin: "left"
                                                }}
                                            />    
                                        </span>
                                        </motion.span>
                                        <motion.span 
                                            variants={posterTextVariants} 
                                            custom={0}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                                    marginRight: "3px"
                                                }}>
                                                    <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                                    marginRight: "10px"
                                                }}>
                                                    <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                            </svg>
                                        </motion.span>
                                    </>
                                }
                                {
                                    !isMobView && 
                                    <motion.span variants={posterTextVariants} 
                                        custom={0}
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                        }}    
                                    >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                                marginRight: "6px"
                                            }}>
                                                <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 13 13" fill="none" style={{
                                                marginRight: "12px"
                                            }}>
                                                <path d="M6.66 12.692L0.612 6.656L6.66 0.607999L12.696 6.656L6.66 12.692Z" fill="white"/>
                                        </svg>2023 - 2025 
                                    </motion.span>
                                }

                        </div>
                       

                        <div className="poster-text lower-loader-text__wrapper" style={{
                        }}>
                            <motion.span variants={posterTextVariants} custom={2}>BORN <span style={{
                                color: "var(--don-red)"
                            }}>RISK</span> TAKERS</motion.span>
                            <motion.span variants={posterTextVariants} custom={3}>@DONPROD</motion.span>
                        </div>
                    </motion.div>

                </motion.div>
                
                {startPreloader && useMobileVideoPreload !== null &&
                    <div className="preload_info">
                        <div className="load-text" style={{ opacity: 0, position: "absolute"}}>
                            <img 
                                src="../media/branding/centerskew_crop.jpeg"
                                style={{
                                    filter: "invert(1)",
                                    maxWidth: "800px",
                                    position: "absolute",
                                    top: 0,
                                    zIndex: -100
                                }}    
                            />
                            <img 
                                src="../media/branding/centerskewblack.png"
                                style={{
                                    filter: "invert(1)",
                                    maxWidth: "800px",
                                    position: "absolute",
                                    top: 0,
                                    zIndex: -100
                                }}    
                            />
                            <span style={{fontFamily: "var(--font-bold)", opacity: 0, position: "absolute"}}>preload.</span>
                            <span style={{fontFamily: "var(--font-punchy)",  opacity: 0, position: "absolute"}}>preload.</span>
                            <span style={{fontFamily: "sporty pro black",  opacity: 0, position: "absolute"}}>preload.</span>
                        </div>
                        {
                            isMobView ? 
                                <>
                                    {
                                        location.pathname !== "/" ?
                                            <>
                                            {
                                                projData.map((item, idx) => (
                                                    <>
                                                        <img src={item.thumbnails.placeholder} style={{opacity: "0", position: "absolute", top: 0, left: 0, transform: "rotateZ(0.01deg)"}} /> 
                                                        <img src={item.thumbnails.mobile} style={{opacity: "0", position: "absolute", top: 0, left: 0, transform: "rotateZ(0.01deg)"}} /> 
                                                    </>
                                                ))
                                            }

                                            </>
                                        :
                                            <></>

                                    }
                                </>
                            :
                                location.pathname !== "/" ?
                                    <>
                                        {
                                            projData.map((item, idx) => (
                                                <>
                                                    <img src={item.thumbnails.placeholder} style={{opacity: "0", position: "absolute", top: 0, left: 0, transform: "rotateZ(0.01deg)"}} />
                                                    <img src={item.thumbnails.placeholder.replace("placeholder", screenSize)} style={{opacity: "0", position: "absolute", top: 0, left: 0, transform: "rotateZ(0.01deg)"}} />
                                                    {
                                                        <video style={{opacity: "0", position: "absolute", top: 0, left: 0, transform: "rotateZ(0.01deg)"}}>
                                                            <source src={
                                                                useMobileVideoPreload? 
                                                                    item.gifStyling.mobileVideo
                                                                :
                                                                    item.gifStyling.backgroundImage} 
                                                                type="video/mp4" 
                                                                media="(min-width: 601px)"
                                                            />
                                                        </video>
                                                    }
                                                    
                                                </>
                                            ))
                                        }
                                    </>
                                :
                                    <>
                                    </>
                        }
                    </div>
                }
            </>
            
        }
        </>
    )
}

export default Loader